import React, { useState, useEffect } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import SideDrawer from 'components/SideDrawer/SideDrawer'
import TopBar from 'components/TopBar/TopBar'
import { Outlet } from 'react-router-dom'
import { MainLayoutElements } from './MainLayoutElements'
import Footer from 'components/Footer/Footer'
import WeeklyContextBanner from 'components/WeeklyContextBanner/WeeklyContextBanner'

export default function MainLayout(): JSX.Element {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [open, setOpen] = useState(false)

  // Close sidebar when switching to mobile, open when switching to desktop
  useEffect(() => {
    setOpen(!isMobile)
  }, [isMobile])

  return (
    <MainLayoutElements.Root>
      <SideDrawer open={open} setOpen={setOpen} isMobile={isMobile} />
      <MainLayoutElements.ContentWrapper open={open} isMobile={isMobile}>
        <TopBar open={open} setOpen={setOpen} isMobile={isMobile} />
        <WeeklyContextBanner />
        <MainLayoutElements.Content component="main">
          <Outlet />
          <Footer />
        </MainLayoutElements.Content>
      </MainLayoutElements.ContentWrapper>
    </MainLayoutElements.Root>
  )
}